// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export {
  useRequest,
  UseRequestProvider,
  request,
  getRequestInstance,
} from './request';
